module.exports = __webpack_public_path__ + "static/img/jp5.9fa497d4.png";